import ky from 'ky'
import type { KyInstance } from 'ky'
import { ROUTES } from '@/shared/lib/routes'
import { deviceStorage, STORAGE_KEYS } from '@/shared/lib/storage'

const isProxy = import.meta.env.VITE_PROXY === 'true'
const SERVERS: Record<string, string> = {
  local: isProxy ? '/api-proxy' : 'http://localhost:3000',
  staging: 'https://ttpp.fiduly.com',
  production: 'https://server.fiduly.com',
}

export type ServerEnv = 'local' | 'staging' | 'production'

function getInitialServer(): ServerEnv {
  const saved = deviceStorage.get(
    STORAGE_KEYS.device.server,
  ) as ServerEnv | null
  if (saved && saved in SERVERS) return saved
  const envUrl = import.meta.env.VITE_API_URL || ''
  if (envUrl.includes('localhost') || envUrl.includes('trycloudflare'))
    return 'local'
  if (envUrl.includes('ttpp') || envUrl.includes('expstage')) return 'staging'
  return 'production'
}

let currentServer: ServerEnv = getInitialServer()

export function getServerEnv(): ServerEnv {
  return currentServer
}

export function setServerEnv(env: ServerEnv) {
  currentServer = env
  deviceStorage.set(STORAGE_KEYS.device.server, env)
  window.location.reload()
}

export function getServerUrl(): string {
  return SERVERS[currentServer]
}

function createApi(): KyInstance {
  return ky.create({
    prefixUrl: getServerUrl(),
    credentials: 'include',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
    retry: { limit: 1, methods: ['get'], statusCodes: [408, 502, 503, 504] },
    hooks: {
      afterResponse: [
        async (_request, _options, response) => {
          if (
            response.status === 401 &&
            !window.location.pathname.startsWith(ROUTES.login)
          ) {
            // Skip redirect for session check — AuthGuard handles it with auto-login
            if (new URL(_request.url).pathname.endsWith('/users/profile'))
              return
            // Don't redirect for permission errors (NOTAUTHORIZED) — only for expired sessions
            try {
              const body = (await response.clone().json()) as { code?: string }
              if (body?.code === 'NOTAUTHORIZED') return
            } catch {
              /* not JSON, treat as session expiry */
            }
            window.location.href = ROUTES.login
          }
        },
      ],
    },
  })
}

export const api = createApi()
